/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VisualReference } from './VisualReference';
import {
    VisualReferenceFromJSON,
    VisualReferenceFromJSONTyped,
    VisualReferenceToJSON,
    VisualReferenceToJSONTyped,
} from './VisualReference';
import type { MedicareConditionsServices } from './MedicareConditionsServices';
import {
    MedicareConditionsServicesFromJSON,
    MedicareConditionsServicesFromJSONTyped,
    MedicareConditionsServicesToJSON,
    MedicareConditionsServicesToJSONTyped,
} from './MedicareConditionsServices';

/**
 * 
 * @export
 * @interface NtaConditionEvidence
 */
export interface NtaConditionEvidence {
    /**
     * 
     */
    condition: MedicareConditionsServices;
    /**
     * found=Clear evidence, maybe=Needs confirmation, not_found=Evidence unclear or not present
     */
    evidence_rating: NtaConditionEvidenceEvidenceRatingEnum;
    /**
     * 
     */
    rationale: string;
    /**
     * True if the evidence_rating was manually changed from the AI prediction
     */
    is_manually_changed?: boolean;
    /**
     * The original AI-predicted evidence rating before manual change
     */
    original_evidence_rating?: NtaConditionEvidenceOriginalEvidenceRatingEnum;
    /**
     * The original AI-generated rationale before manual change
     */
    original_rationale?: string;
    /**
     * Visual references specific to this NTA condition evidence
     */
    visual_references?: Array<VisualReference>;
}


/**
 * @export
 */
export const NtaConditionEvidenceEvidenceRatingEnum = {
    Found: 'found',
    Maybe: 'maybe',
    NotFound: 'not_found',
} as const;
export type NtaConditionEvidenceEvidenceRatingEnum = typeof NtaConditionEvidenceEvidenceRatingEnum[keyof typeof NtaConditionEvidenceEvidenceRatingEnum];

/**
 * @export
 */
export const NtaConditionEvidenceOriginalEvidenceRatingEnum = {
    Found: 'found',
    Maybe: 'maybe',
    NotFound: 'not_found',
} as const;
export type NtaConditionEvidenceOriginalEvidenceRatingEnum = typeof NtaConditionEvidenceOriginalEvidenceRatingEnum[keyof typeof NtaConditionEvidenceOriginalEvidenceRatingEnum];


/**
 * Check if a given object implements the NtaConditionEvidence interface.
 */
export function instanceOfNtaConditionEvidence(value: object): value is NtaConditionEvidence {
    if (!('condition' in value) || value['condition'] === undefined) return false;
    if (!('evidence_rating' in value) || value['evidence_rating'] === undefined) return false;
    if (!('rationale' in value) || value['rationale'] === undefined) return false;
    return true;
}

export function NtaConditionEvidenceFromJSON(json: any): NtaConditionEvidence {
    return NtaConditionEvidenceFromJSONTyped(json, false);
}

export function NtaConditionEvidenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): NtaConditionEvidence {
    if (json == null) {
        return json;
    }
    return {
        
        'condition': MedicareConditionsServicesFromJSON(json['condition']),
        'evidence_rating': json['evidence_rating'],
        'rationale': json['rationale'],
        'is_manually_changed': json['is_manually_changed'] == null ? undefined : json['is_manually_changed'],
        'original_evidence_rating': json['original_evidence_rating'] == null ? undefined : json['original_evidence_rating'],
        'original_rationale': json['original_rationale'] == null ? undefined : json['original_rationale'],
        'visual_references': json['visual_references'] == null ? undefined : ((json['visual_references'] as Array<any>).map(VisualReferenceFromJSON)),
    };
}

export function NtaConditionEvidenceToJSON(json: any): NtaConditionEvidence {
    return NtaConditionEvidenceToJSONTyped(json, false);
}

export function NtaConditionEvidenceToJSONTyped(value?: NtaConditionEvidence | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'condition': MedicareConditionsServicesToJSON(value['condition']),
        'evidence_rating': value['evidence_rating'],
        'rationale': value['rationale'],
        'is_manually_changed': value['is_manually_changed'],
        'original_evidence_rating': value['original_evidence_rating'],
        'original_rationale': value['original_rationale'],
        'visual_references': value['visual_references'] == null ? undefined : ((value['visual_references'] as Array<any>).map(VisualReferenceToJSON)),
    };
}

